export default __webpack_public_path__ + "static/media/userBg.33c2410b.png";